import { IconProps } from "../../utils/global-types/global-types";

const WeChatIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="#fff"
      d="M.5 7.246c0 1.56.835 2.983 2.133 3.94.108.078.17.202.17.34 0 .047-.016.094-.016.14-.108.386-.262 1.02-.278 1.05a.6.6 0 0 0-.03.155c0 .108.092.201.2.201.046 0 .077-.015.124-.046l1.344-.788a.65.65 0 0 1 .325-.093c.062 0 .123.015.185.03a7.2 7.2 0 0 0 2.01.28c3.4 0 6.15-2.335 6.15-5.21s-2.766-5.207-6.166-5.207S.5 4.37.5 7.246"
    ></path>
    <path
      fill="url(#paint0_linear_6997_93763)"
      d="M.5 7.246c0 1.56.835 2.983 2.133 3.94.108.078.17.202.17.34 0 .047-.016.094-.016.14-.108.386-.262 1.02-.278 1.05a.6.6 0 0 0-.03.155c0 .108.092.201.2.201.046 0 .077-.015.124-.046l1.344-.788a.65.65 0 0 1 .325-.093c.062 0 .123.015.185.03a7.2 7.2 0 0 0 2.01.28c3.4 0 6.15-2.335 6.15-5.21s-2.766-5.207-6.166-5.207S.5 4.37.5 7.246"
    ></path>
    <path
      fill="url(#paint1_linear_6997_93763)"
      d="M7.238 11.11c0 2.395 2.303 4.327 5.131 4.327q.88 0 1.67-.232c.046-.015.092-.015.154-.015a.6.6 0 0 1 .278.077l1.128.664c.031.016.062.031.093.031.092 0 .17-.077.17-.17a.3.3 0 0 0-.031-.123c0-.031-.14-.541-.232-.881-.015-.031-.015-.078-.015-.108a.35.35 0 0 1 .139-.279c1.082-.788 1.777-1.962 1.777-3.276 0-2.395-2.303-4.327-5.13-4.327-2.83-.031-5.132 1.916-5.132 4.312"
    ></path>
    <path
      fill="#919191"
      d="M13.451 9.78c0 .387.31.696.68.696a.68.68 0 0 0 .68-.696.69.69 0 0 0-.68-.695.69.69 0 0 0-.68.695M10.02 9.78c0 .387.31.696.68.696a.68.68 0 0 0 .68-.696.69.69 0 0 0-.68-.695.69.69 0 0 0-.68.695"
    ></path>
    <path
      fill="#168743"
      d="M5.414 5.561c0 .464-.37.835-.819.835a.83.83 0 0 1-.819-.835c0-.463.371-.834.82-.834.463 0 .818.386.818.834M9.54 5.561c0 .464-.37.835-.819.835a.83.83 0 0 1-.819-.835c0-.463.371-.834.82-.834.447 0 .818.386.818.834"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_6997_93763"
        x1="6.657"
        x2="6.657"
        y1="13.056"
        y2="2.038"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.06" stopColor="#05CD66"></stop>
        <stop offset="0.22" stopColor="#0ED169"></stop>
        <stop offset="0.48" stopColor="#26DB6F"></stop>
        <stop offset="0.807" stopColor="#4DEB7A"></stop>
        <stop offset="0.952" stopColor="#61F380"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_6997_93763"
        x1="12.373"
        x2="12.373"
        y1="15.947"
        y2="6.771"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.081" stopColor="#D9D9D9"></stop>
        <stop offset="1" stopColor="#F0F0F0"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default WeChatIcon;
